import React, { useEffect, useRef } from 'react';
export function MapInfoWindow({ children, map, marker, onClosed, visible, }) {
    const infoWindowRef = useRef(null);
    const contentContainerRef = useRef(null);
    const setContent = () => {
        const { current: infoWindow } = infoWindowRef;
        const { current: contentContainer } = contentContainerRef;
        if (infoWindow !== null && contentContainer !== null) {
            infoWindow.setContent(contentContainer.innerHTML);
        }
    };
    useEffect(() => {
        if (infoWindowRef.current) {
            return;
        }
        // Create the info window on mount
        // eslint-disable-next-line no-undef
        const infoWindow = new google.maps.InfoWindow();
        infoWindow.addListener('closeclick', () => {
            if (onClosed) {
                onClosed();
            }
        });
        infoWindowRef.current = infoWindow;
    }, [onClosed]);
    useEffect(() => {
        const { current: infoWindow } = infoWindowRef;
        if (infoWindow !== null && map !== null && marker !== null && visible) {
            infoWindow.open(map, marker);
        }
    }, [map, marker, visible]);
    useEffect(() => {
        if (children) {
            setContent();
        }
    }, [children]);
    // The required info window content is rendered to a hidden div.
    return (React.createElement("div", { style: { display: 'none' }, ref: contentContainerRef }, children));
}
